<template>
  <TransactionListTemplate
    :screen-config="setScreenConfig"
    :row-click="rowClickCallBack"
    persistence-key="Work-Order-releases-list"
    :setLoading="setLoading"
    ref="work-order-releases-list"
  >
    <template #popup>
      <!-- // The popup for creating a new release and displaying release information -->
      <!-- // This popup is shown when the "Add New" button is clicked and a row is clicked in the releases list -->
      <gcPopupReleaseModel
        :popupConfig="popup"
        :on-hide="onPopupHide"
        v-if="popup.isPopupShow"
        :showLoading="ShowLoading"
        @onRefreshDataList="onRefreshDataList"
        :popup-mode="popup.popupMode"
      />
    </template>
  </TransactionListTemplate>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "@/_mixins/data-grid.mixin";

import TransactionListTemplate from "@/templates/transaction-list";
import { FeatureStorage } from "@/_services/storage";
import ColumnWidth from "@/_helpers/data-grid/ColumnWidth";
// import { WorkOrderService } from "@/_services/api/production/work-order.service";
import {
  GetIndexByTabName,
  WorkOrderTabs,
} from "../../../_models/tabdata/production/work-order-tabs";
import gcPopupReleaseModel from "../../../popups/work-order/gc-popup-release-model.vue";
import { getBranchFieldDefault } from "../../../_helpers/default-value-rules/default-value-rules";
import { ProductionReleaseService } from "../../../_services/api/production/production-release.service";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: {
    TransactionListTemplate,
    gcPopupReleaseModel,
  },
  data() {
    return {
      transactionListKey: 0,
      model: {
        BomCode: null,
        Branch: null,
        QuoteCode: 0,
        Code: 0,
        Comments: "",
        CompanyCode: "",
        Division: null,
        Product: null,
        Quantity: 0,
        Required: new Date(),
        Scheduled: new Date(),
        DateIn: new Date(),
      },
      initialModel: null, // To store the initial state
      popup: {
        title: "",
        secondaryTitle: undefined,
        isFormLoading: false,
        popupKey: 0,
        formKey: 0,
        height: 370,
        isPopupShow: false,
        hideOnOutsideClick: false,
        // toolbarMenuItems: [
        //   {
        //     menuText: "Copy",
        //     visible: false, // pending discussions #54331
        //   },
        //   { menuText: "Cancel", onClick: this.onCancelWorkOrderHandler },
        //   { menuText: "Reopen", onClick: this.onReopenWorkOrderHandler },
        //   { menuText: "Complete", onClick: this.onCompleteWorkOrderHandler },
        // ],
        formMode: "create",
        isEditable: false,
        dataModel: {
          BranchCode: undefined,
          ReleaseDate: undefined,
        },
      },
      setLoading: false,
      dataModel: undefined,
      WorkOrderInstance: "Core",
      releasePopupInfo: {
        isPopupShow: false,
        dataModel: {},
        popupMode: "create", // or 'view' based on the context
      },
    };
  },
  computed: {
    setScreenConfig() {
      return {
        title: "Work Orders",
        ScreenName: "Work Orders Releases",
        exportFileName: "Work Order List - Releases",
        selectedIndex: GetIndexByTabName("Releases"),
        tabs: WorkOrderTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "ProductionReleaseList",
              //   filter: [[["FriendlyStatus", "=", "Completed"]]],
              serverPaging: true,
              allowGrouping: false,
            },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Releases",
                message: "Get Started, Add a Releases",
              },
            },
            // options: {
            //   selectionMode: "multiple",
            // },
          },
          toolbar: {
            screenName: "Work Orders Releases",
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            multiplePdf: true,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                clickAction: this.onNewReleaseHandler,
                buttonLocation: "left",
                visible: FeatureStorage.checkPermission(
                  "WorkOrderProductionRelease",
                  "create"
                ),
              },
            ],
          },
          columns: [
            {
              screenField: "Release",
              label: "Release No",
              dataField: "ProductionReleaseCode",
              allowHiding: false,
              fixed: true,
              fixedPosition: "left",
              minWidth: ColumnWidth.PurchaseOrderCode.minWidth,
              width: ColumnWidth.PurchaseOrderCode.width,
              sortIndex: 0,
              sortOrder: "desc",
              filterIndex: 1,
              type: "Integer",
              filterLabel: "Release No",
              filterDataField: "ProductionReleaseCode",
            },
            {
              screenField: "Code",
              filterLabel: "Work Order",
              label: "Work Order",
              gridDataField: "WorkOrderCode",
              minWidth: ColumnWidth.PurchaseOrderCode.minWidth,
              width: ColumnWidth.PurchaseOrderCode.width,
              filterIndex: 2,
              type: "Integer",
              filterDataField: "WorkOrderCode",
            },
            {
              screenField: "Product",
              gridDataField: "PlannedProductDescription",
              label: "Planned Product",
              minWidth: ColumnWidth.ProductOrAccount.minWidth,
              width: ColumnWidth.ProductOrAccount.width,
              allowHiding: false,
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "PlannedProductDescription",
                  },
                ],
                secondary: [
                  {
                    dataField: "PlannedProductCode",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "PlannedProductCode",
                  label: "Planned Product Code",
                },
                {
                  dataField: "PlannedProductDescription",
                  label: "Planned Product Description",
                },
              ],
              filterIndex: 5,
              filterDataField: "PlannedProductCode",
              filterLabel: "Planned Product",
              filterOverWrites: {
                select: [
                  "Code",
                  "Description1",
                  "Inactive",
                  "Status",
                  "Source",
                ],
                filter: [
                  ["Inactive", "=", "N"],
                  "and",
                  ["Status", "=", "A"],
                  "and",
                  ["Source", "=", "M"],
                ],
              },
            },
            {
              screenField: "Product",
              gridDataField: "ReleasedProductDescription1",
              label: "Released Product",
              minWidth: ColumnWidth.ProductOrAccount.minWidth,
              width: ColumnWidth.ProductOrAccount.width,
              allowHiding: false,
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "ReleasedProductDescription1",
                  },
                ],
                secondary: [
                  {
                    dataField: "ReleasedProductCode",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "ReleasedProductCode",
                  label: "Released Product Code",
                },
                {
                  dataField: "ReleasedProductDescription1",
                  label: "Released Product Description",
                },
              ],
              filterIndex: 6,
              filterDataField: "ReleasedProductCode",
              filterLabel: "Released Product",
              filterOverWrites: {
                select: [
                  "Code",
                  "Description1",
                  "Inactive",
                  "Status",
                  "Source",
                ],
                filter: [
                  ["Inactive", "=", "N"],
                  "and",
                  ["Status", "=", "A"],
                  "and",
                  ["Source", "=", "M"],
                ],
              },
            },
            {
              screenField: "DateIn",
              dataField: "ReleaseDate",
              filterDataField: "ReleaseDate",
              label: "Released Date",
              filterIndex: 3,
            },
            {
              screenField: "DateCreated",
              filterIndex: 4,
            },
            {
              screenField: "CreatedBy",
            },
          ],
        },
      };
    },
  },
  async created() {},
  methods: {
    onRefreshDataList() {
      this.$refs["work-order-releases-list"].$refs[
        "transactionListGrid"
      ].gridRepaint();
    },
    /**
     * Show Loading
     * @param value
     * @constructor
     */
    ShowLoading(value) {
      this.setLoading = value;
    },
    /**
     * Hide A popup
     */
    onPopupHide() {
      this.popup.dataModel = {};
      this.popup.isPopupShow = false;
      this.releasePopupInfo.isPopupShow = false;
    },

    /**
     * On New Work Order Handler
     */
    async onNewReleaseHandler() {
      this.popup.popupKey++;
      this.popup.dataModel.BranchCode = await getBranchFieldDefault(
        this.$store
      );
      this.popup.hideOnOutsideClick = false;

      this.popup.dataModel.ReleaseDate = new Date();
      this.popup.formMode = "create";
      this.popup.popupMode = "create";

      this.popup.isPopupShow = true;
    },

    /**
     * On Row Click CallBack
     * @param e
     */
    async rowClickCallBack(e) {
      if (
        e.rowType === "data" &&
        e.column.screenField !== "Status" &&
        e.column.screenField !== "GridRecordPDFView" &&
        e.column.screenField !== "GridRecordEllipsisMenu" &&
        e.column.screenField !== "GridRecordPrint" &&
        e.column.type !== "selection"
      ) {
        this.showLoading(true);
        try {
          const response =
            await ProductionReleaseService.getProductionReleaseHeader(
              e.data.ProductionReleaseCode
            );
          if (response && response.data && response.data.value.length > 0) {
            this.popup.popupMode = "review";
            this.popup.dataModel = {
              BranchCode: response.data.value[0].BranchCode,
              WorkOrderCode: e.data.WorkOrderCode,
              ReleaseDate: response.data.value[0].DateIn.replace("Z", ""),
              ProductCode: e.data.ReleasedProductCode,
              ProductDescription: e.data.ReleasedProductDescription1,
              ProductionReleaseCode: e.data.ProductionReleaseCode,
            };
            this.popup.isPopupShow = true;
          } else {
            this.displayServerError(null, "No data found in the response");
          }
        } catch (error) {
          this.displayServerError(
            error,
            "Error fetching production release details"
          );
          return;
        } finally {
          this.showLoading(false);
        }
      }
    },
  },
};
</script>

<style lang="scss"></style>
